<template>
  <ion-page>
    <ion-content class="ion-padding ion-content-login">
      <form class="fullheight xc">
        <parallax-star v-if="bgParallaxStar" />
        <ion-grid>
          <ion-row
            style="height: 100%;"
            class="ion-align-items-center ion-justify-content-center"
          >
            <ion-col align-self-center size-md="6" size-lg="4" size-xs="12">
              <div class="ion-text-center ion-text-color-withe">
                <h3>Iniciar</h3>
              </div>
              <div class="ion-padding">
                <ion-item class="ion-margin-bottom roundedInput">
                  <ion-input
                    name="email"
                    type="email"
                    v-model="model.email"
                    placeholder="Ingrese su usuario"
                  ></ion-input>
                </ion-item>
                <ion-item class="roundedInput">
                  <ion-input
                    name="password"
                    type="password"
                    v-model="model.password"
                    placeholder="Ingrese su contraseña"
                  ></ion-input>
                </ion-item>
              </div>
              <div class="ion-padding">
                <ion-button
                  :disabled="throttleState"
                  size="default"
                  type="button"
                  expand="block"
                  @click="login"
                  >{{
                    throttleState
                      ? 'Intentar en ' + retryAfterLabel + ' Seg.'
                      : 'Ingresar'
                  }}</ion-button
                >
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
      <bg-wave-animation v-if="bgWaveAnimation" />
    </ion-content>
  </ion-page>
</template>

<script>
import BgWaveAnimation from '@/components/bgPage/wave_animation.vue'
import ParallaxStar from '@/components/bgPage/parallax_star.vue'
export default {
  components: {
    BgWaveAnimation,
    ParallaxStar
  },
  data() {
    return {
      bgWaveAnimation: false,
      bgParallaxStar: true,
      model: {
        email: '',
        password: '',
        remember: false,
        guard: 'employee'
      },
      errorsAuth: {},
      retryAfterLabel: ''
    }
  },
  methods: {
    login() {
      this.$emitter.emit('VS_LOADING', { action: 'open' })
      this.errorsAuth = {}
      let formData = new FormData()
      formData.append('email', this.model.email)
      formData.append('password', this.model.password)
      formData.append('guard', this.model.guard)
      if (this.model.remember) formData.append('remember', this.model.remember)
      this.$http
        .post('app-manage/login', formData)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            console.log(response)
            //this.$emitter.emit('VS_LOADING', { action: 'close' })
            this.$store.dispatch('auth/setLoggedStatus', true)
            //this.$store.dispatch('auth/login', response.data.user)
            //this.$store.dispatch('auth/token', response.data.token)
            //this.$store.dispatch('auth/guard', this.model.guard)
            this.$router.push({ name: 'home' })
          }
        )
        .catch((error) => {
          console.log(error)
          this.$emitter.emit('VS_LOADING', { action: 'close' })
          if (error.response.status === 429) {
            var str = error.response.data.errors.email[0]
            var retryAfter = str.match(/^\d+|\d+\b|\d+(?=\w)/g).map((v) => {
              return +v
            })
            this.throttleLogin(retryAfter[0])
            this.errorsAuth = error.response.data.errors
            //this.$snotify.error(error.response.data.errors.email[0], 'Error')
            this.$emitter.emit('VS_LOADING', { action: 'close' })
          } else {
            //let message = 'Error en la petición.'
            if (error.response.data.message) {
              //message = error.response.data.message
            }
            //this.$snotify.error(message, 'Error')
            if (error.response.data.errors) {
              this.errorsAuth = error.response.data.errors
              this.$emitter.emit('VS_LOADING', { action: 'close' })
            }
          }
        })
    },
    throttleLogin(retryAfter) {
      this.retryAfterLabel = retryAfter
      this.$store.dispatch('auth/throttle')
      var timeleft = retryAfter
      var downloadTimer = setInterval(() => {
        if (timeleft <= 0) {
          clearInterval(downloadTimer)
          this.$store.dispatch('auth/throttle')
          this.retryAfterLabel = ''
          this.errorsAuth = {}
        } else {
          this.retryAfterLabel = timeleft
          timeleft--
        }
      }, 1000)
    }
  }
}
</script>

<style>
.roundedInput {
  --border-color: var(--ion-color-medium-shade);
  --border-radius: 5px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: #f8f9fa;
}

.fullheight {
  height: 100%;
}

.xc {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-to-parallax-star {
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
}

.ion-content-login {
  --background: radial-gradient(ellipse at bottom, #1b2735 0%, #000 100%);
}
</style>
